<template>
  <svg
    v-if="gSiteName === 'xoilaczxc'"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_15_5385)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.51787 7.85269L0.0280307 15.8102C-0.062234 16.2967 0.0679373 16.7984 0.383389 17.1785C0.69979 17.5595 1.16822 17.7799 1.66325 17.779H4.01583C3.75929 17.4692 3.57211 17.0968 3.48089 16.6834L1.51787 7.85269Z"
        fill="#7E8793"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.6997 3.09051L12.2916 5.70343C12.3781 6.08729 12.7601 6.32768 13.1439 6.24122C13.5268 6.15475 13.7682 5.77279 13.6817 5.38893L13.0907 2.776C13.0033 2.39214 12.6213 2.15175 12.2384 2.23822C11.8546 2.32468 11.6132 2.70664 11.6997 3.09051Z"
        fill="#7E8793"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.52378 3.09051L6.11573 5.70343C6.20219 6.08729 6.58415 6.32768 6.96802 6.24122C7.35093 6.15475 7.59227 5.77279 7.5058 5.38893L6.91481 2.776C6.82739 2.39214 6.44543 2.15175 6.06252 2.23822C5.67866 2.32468 5.43732 2.70664 5.52378 3.09051Z"
        fill="#7E8793"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.5096 9.22757H2.79687L4.40834 16.4773C4.57746 17.2383 5.25207 17.7799 6.0312 17.779H18.3367C18.8412 17.779 19.3182 17.5509 19.6336 17.1576C19.95 16.7633 20.0697 16.2483 19.9605 15.7561L18.5096 9.22757ZM6.3533 3.52664H3.60356C3.09902 3.52759 2.62205 3.75563 2.30659 4.14899C1.99019 4.54331 1.87047 5.05829 1.97974 5.55047L2.48047 7.80234H18.1932L17.5319 4.8293C17.3628 4.06823 16.6881 3.52664 15.909 3.52664H14.2348L14.6083 5.17896C14.8106 6.07401 14.2481 6.96525 13.3531 7.16764L12.5293 3.52664H8.05883L8.43224 5.17896C8.63463 6.07401 8.07213 6.96525 7.17709 7.16764L6.3533 3.52664Z"
        fill="#7E8793"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_5385">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
  <svg
    v-else-if="gSiteName === 'xoilactivi'"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="as-not-change-color"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.51787 7.85266L0.0280307 15.8102C-0.062234 16.2967 0.0679373 16.7984 0.383389 17.1784C0.69979 17.5594 1.16822 17.7799 1.66325 17.7789H4.01583C3.75929 17.4692 3.57211 17.0967 3.48089 16.6834L1.51787 7.85266Z"
      fill="#00FF5E"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.6997 3.09047L12.2916 5.7034C12.3781 6.08726 12.7601 6.32765 13.1439 6.24119C13.5268 6.15472 13.7682 5.77276 13.6817 5.3889L13.0907 2.77597C13.0033 2.39211 12.6213 2.15172 12.2384 2.23819C11.8546 2.32465 11.6132 2.70661 11.6997 3.09047Z"
      fill="#00FF5E"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.5239 3.09047L6.11585 5.7034C6.20231 6.08726 6.58428 6.32765 6.96814 6.24119C7.35105 6.15472 7.59239 5.77276 7.50593 5.3889L6.91493 2.77597C6.82752 2.39211 6.44555 2.15172 6.06264 2.23819C5.67878 2.32465 5.43744 2.70661 5.5239 3.09047Z"
      fill="#00FF5E"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.5093 9.22754H2.79663L4.40809 16.4772C4.57722 17.2383 5.25183 17.7799 6.03096 17.7789H18.3364C18.8409 17.7789 19.3179 17.5509 19.6334 17.1575C19.9498 16.7632 20.0695 16.2482 19.9602 15.7561L18.5093 9.22754ZM6.35306 3.52661H3.60331C3.09878 3.52756 2.6218 3.7556 2.30635 4.14896C1.98995 4.54328 1.87023 5.05826 1.9795 5.55044L2.48023 7.80231H18.1929L17.5316 4.82927C17.3625 4.0682 16.6879 3.52661 15.9088 3.52661H14.2346L14.608 5.17893C14.8104 6.07398 14.2479 6.96522 13.3529 7.16761L12.5291 3.52661H8.05859L8.432 5.17893C8.63438 6.07398 8.07189 6.96522 7.17684 7.16761L6.35306 3.52661Z"
      fill="#B4BEC1"
    />
  </svg>
  <svg
    v-else
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_406_2706)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.07607 4.18824C6.07645 4.57634 5.76145 4.89096 5.37296 4.89096C4.98444 4.89096 4.66986 4.57638 4.66986 4.18786V1.12107C4.66986 0.732591 4.98483 0.417969 5.37296 0.417969C5.7611 0.417969 6.07607 0.732591 6.07607 1.12107V4.18824ZM19.2924 2.0329H16.7127C16.3243 2.0329 16.0093 2.34752 16.0093 2.736C16.0093 3.12448 16.3242 3.43911 16.7127 3.43911H18.5897V18.1778H1.40617V3.43911H3.42441C3.8125 3.43911 4.12751 3.12448 4.12751 2.736C4.12751 2.34752 3.81289 2.0329 3.42441 2.0329H0.703061C0.314966 2.0329 0 2.34752 0 2.736V18.8808C0 19.2689 0.314966 19.5835 0.703104 19.5835H19.2928C19.6812 19.5835 19.9959 19.2689 19.9955 18.8808V2.736C19.9955 2.34752 19.6809 2.0329 19.2924 2.0329ZM7.30174 3.43911H12.7871C13.1756 3.43911 13.4906 3.12448 13.4906 2.736C13.4906 2.34752 13.1756 2.0329 12.7871 2.0329H7.30174C6.91364 2.0329 6.59863 2.34752 6.59863 2.736C6.59863 3.12448 6.91325 3.43911 7.30174 3.43911ZM14.7493 4.89096C15.1374 4.89096 15.452 4.57634 15.4524 4.18824V1.12107C15.4524 0.732591 15.1378 0.417969 14.7493 0.417969C14.3608 0.417969 14.0458 0.732591 14.0458 1.12107V4.18786C14.0459 4.57638 14.3608 4.89096 14.7493 4.89096ZM15.5663 10.8078C15.5659 13.8781 13.0681 16.3751 9.99792 16.3751C6.92809 16.3751 4.4303 13.8777 4.4303 10.8078C4.4303 7.73802 6.92809 5.241 9.99792 5.241C13.0681 5.241 15.5663 7.7384 15.5663 10.8078ZM14.1593 10.8078C14.1593 8.51387 12.2923 6.64682 9.99792 6.64682C7.70355 6.64682 5.83689 8.51348 5.83689 10.8078C5.83689 13.1022 7.70355 14.9693 9.99792 14.9693C12.2927 14.9693 14.1593 13.1026 14.1593 10.8078ZM10.909 12.1138L11.4722 10.3805L9.99788 9.30872L8.52313 10.3805L9.08684 12.1138H10.909ZM11.2213 7.47517L11.3908 7.75777L9.99756 8.30393L8.60431 7.75777L8.77417 7.47517C9.1566 7.335 9.56753 7.255 9.99756 7.255C10.4283 7.255 10.8393 7.335 11.2213 7.47517ZM13.5366 11.2866C13.556 11.1354 13.5685 10.983 13.5685 10.8273C13.5685 10.1162 13.3587 9.45534 13.0011 8.89888L12.6872 8.79489L12.4587 10.2746L13.297 11.5135L13.5366 11.2866ZM10.5021 14.1591L11.3724 12.9415L12.8388 12.641L12.851 12.9693C12.3524 13.6301 11.6326 14.1123 10.7996 14.3042L10.5021 14.1591ZM7.15696 12.641L7.14594 12.9693C7.64411 13.6301 8.36395 14.1123 9.19692 14.3043L9.49438 14.1592L8.62407 12.9415L7.15696 12.641ZM6.99514 8.89853L7.30899 8.79416L7.53675 10.2739L6.69807 11.5128L6.45963 11.2855C6.44057 11.1347 6.42688 10.9827 6.42688 10.8269C6.42688 10.1158 6.63636 9.45499 6.99514 8.89853Z"
        fill="#9C9C9C"
      />
    </g>
    <defs>
      <clipPath id="clip0_406_2706">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
export default {};
</script>
